import styled, { css, keyframes } from 'styled-components';
import { THEME } from '@/common/styles/theme';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const MessageActionsRoot = styled.div`
	display: flex;
	align-items: center;
	gap: 3px;
	margin-top: 10px;
	padding: 0 0 6px 8px;
	overflow: visible;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		margin-top: 6px;
		padding: 0 0 4px 4px;
		gap: 2px;
	}
`;

export const ActionIcon = styled.svg`
	width: 16px;
	height: 16px;
	fill: none;
	stroke: currentColor;
	stroke-width: 1.65;
	stroke-linecap: round;
	stroke-linejoin: round;
	flex-shrink: 0;
`;

export const MessageActionButton = styled.button`
	position: relative;
	width: 28px;
	height: 28px;
	display: grid;
	place-items: center;
	border: 0;
	border-radius: 9px;
	padding: 0;
	color: rgba(232, 213, 239, 0.55);
	background: transparent;
	cursor: pointer;
	overflow: visible;
	transition:
		color 150ms ease,
		background 150ms ease,
		box-shadow 150ms ease,
		transform 150ms ease;

	&[data-tooltip]::after {
		content: attr(data-tooltip);
		position: absolute;
		left: 50%;
		bottom: calc(100% + 10px);
		z-index: 20;
		width: max-content;
		max-width: 170px;
		padding: 7px 10px;
		border: 1px solid rgba(255, 214, 255, 0.14);
		border-radius: 9px;
		color: rgba(255, 246, 255, 0.92);
		background: rgba(17, 7, 23, 0.88);
		box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
		backdrop-filter: blur(18px);
		font-size: 0.72rem;
		font-weight: 700;
		line-height: 1;
		white-space: nowrap;
		opacity: 0;
		pointer-events: none;
		transform: translate(-50%, 5px);
		transition: opacity 140ms ease, transform 140ms ease;
	}

	&[data-tooltip]:hover::after,
	&[data-tooltip]:focus-visible::after {
		opacity: 1;
		transform: translate(-50%, 0);
	}

	&:hover,
	&:focus-visible {
		transform: translateY(-1px);
		color: #fff;
		background: rgba(255, 255, 255, 0.065);
		box-shadow: 0 0 14px rgba(255, 77, 242, 0.1);
	}

	${(props) =>
		props.$active &&
		css`
			transform: translateY(-1px);
			color: #ef8cff;
			background: rgba(255, 255, 255, 0.065);
			box-shadow: 0 0 16px rgba(255, 77, 242, 0.24);
		`}

	${(props) =>
		props.$loading &&
		css`
			color: #ef8cff;
			pointer-events: none;
		`}

	&:disabled {
		opacity: 0.35;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 24px;
		height: 24px;
		border-radius: 7px;
	}
`;

export const SpeakerSpinner = styled.span`
	width: 12px;
	height: 12px;
	border: 2px solid rgba(239, 140, 255, 0.25);
	border-top-color: #ef8cff;
	border-radius: 50%;
	animation: ${spin} 0.8s linear infinite;
`;
